import { AxiosResponse } from 'axios';

import { API } from '../../utils/axios';
import { APIResponseStatus, FeatureFlag } from '../types';

class FeatureFlagService {
  static getFeatureFlags(serviceType: string) {
    return API.get<any, AxiosResponse<APIResponseStatus<FeatureFlag[]>>>(
      `v1/auth/feature_flags?service_type=${serviceType}`,
    ).then((res) => {
      return res.data;
    });
  }
}

export default FeatureFlagService;
